module.exports = __webpack_public_path__ + "img/chicken_0327.843fbd4b.png";